<script setup lang="ts">
import { useData } from 'vike-vue/useData'
import type { ProductPageData } from './+data'

const data = useData<ProductPageData>()
</script>

<template>
  <CommonPagesProduct
    :data="data"
    display-breadcrumb
  />
</template>
